import ServerProxy from '../../proxy/ServerProxy';
const notification ={
    state: {
        // eslint-disable-next-line no-undef
        config:config,
        newNotificationNumber:0,
        notifications:[],
        showCommunication: false,
        communicationDetail: null,
        serverProxy: new ServerProxy()
    },
    getters: {
        getNewNotificationNumber(state){
            return state.newNotificationNumber;
        },
        getNotifications(state){
            return state.notifications;
        },
        getShowCommunication(state){
            return state.showCommunication;
        },
        getCommunicationDetail(state){
            return state.communicationDetail;
        }
    },
    actions: {
        fetchNotificationList({commit, state} ,params){
            return new Promise((resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/user/${params.userId}/newcomms`,
                    method: `GET`,
                    headers: { 'Content-Type': `application/json` },

                })
                    .then(response => {
                        if(response.error){
                            commit("setNewNotificationNumber", 0);
                            commit("setNotifications", []);
                        }else{
                            commit("setNewNotificationNumber", response.count);
                            commit("setNotifications", response.list);
                        }
                    })
                    .catch(err =>
                            reject(err)
                    );
            });
        },
        getNotificationBody({state},params){
            return new Promise((resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/user/${params.userId}/newcomms/${params.commId}?isBodyRequired=${params.isBodyRequired}`,
                    method: `Post`,
                    needMask: true,
                    headers: { 'Content-Type': `application/json` },

                })
                    .then(response => {
                       resolve(response);
                    })
                    .catch(err =>
                        reject(err)
                    );
            });
        },
        setShowCommunication({commit}, showCommunication){
            commit("setShowCommunication",showCommunication);
        },
        setCommunicationDetail({commit}, communicationDetail){
            commit("setCommunicationDetail",communicationDetail);
        },
        closeCommunicationDialog({commit}){
            commit("setShowCommunication",false);
            commit("setCommunicationDetail",null);
        }

    },
    mutations: {
        setNewNotificationNumber(state, number){
            state.newNotificationNumber = number;
        },
        setNotifications(state, notifications){
            state.notifications = notifications;
        },
        setShowCommunication(state, showCommunication){
            state.showCommunication = showCommunication;
        },
        setCommunicationDetail(state, communicationDetail){
            state.communicationDetail = communicationDetail;
        }
    }
};
export default notification;